declare namespace $ {

	export class $mol_icon_table extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=table.view.tree.d.ts.map